<template>
  <div class="application section">
    <div class="layout-content">
      <SubTitle
        :text="title"
        :subText="subText"
        class="title"
        :select="false"
      />

      <div class="company-code" style="">
        <div class="content-download">
          <img class="download-img" :src="data.codeImg">
          <div class="download-desc">
            <p class="download-title" >{{data.title}}</p>
            <p class="download-content" >{{data.content}}</p>
          </div>
        </div>
        <img
          class="content-img"
          :src="!isMobile ? data.contentImg : data.contentImgMobile"
        >
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import SubTitle from '@/components/SubTitle.vue'

import VueTypes from 'vue-types'

export default {
  name: 'application',
  components: {
    SubTitle
  },
  props: {
    data: VueTypes.object.def({})
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['isEnLang', 'isMobile']),

    // bgImg () {
    //   // return this.isEnLang ? require('../../assets/img/en/B-02_en.png') : require('../../assets/img/B-02.png')
    //   let url = null
    //   if (this.isEnLang) {
    //     if (this.isMobile) {
    //       url = require('../../assets/img/en/B-02_en_wap.png')
    //     } else {
    //       url = require('../../assets/img/en/B-02_en.png')
    //     }
    //   } else {
    //     url = require('../../assets/img/B-02.png')
    //   }
    //   return url
    // },

    title () {
      return this.isEnLang ? ' Application Scenarios' : '应用场景'
    },

    subText () {
      return this.isEnLang ? 'FINTECHATHON' : 'FINTECHATHON'
    }
  },

  created () {
  },

  methods: {
  }
}
</script>

<style lang="scss" scoped>
.application {
  background: #FFFFFF;

  @include mobile {
    background: #F7F8FA;
  }
}

.company-code {
  display: flex; justify-content: space-between;

  @include mobile {
    background: #FFFFFF;
    flex-direction: column;
  }
}

.content-download {
  box-sizing: border-box;
  width: 280px; height: 370px;
  padding: 40px 32px;
  margin-right: 70px;
  margin: 30px 70px 0 0;
  background: #E7F2FF;
  text-align: center;

  @include mobile {
    display: flex;
    width: auto; height: 119px;
    margin: 8px; padding: 12px;
    background: linear-gradient(360deg, rgba(187,225,255,0) 0%, rgba(#86BEFF, 0.3) 100%);
    text-align: left;
  }
}

.download-img {
  display: inline-block;
  width: 200px; height: 200px;

  @include mobile {
    width: 94px; height: 94px;
    margin-right: 16px;
  }
}

.download-title {
  margin: 30px 0 10px;
  color: #000000;
  font-size: 20px; font-weight: 600;
  line-height: 28px;

  @include mobile {
    margin: 16px 0 12px;
    font-size: 16px;
    line-height: 22px;
  }
}

.download-content {
  color: #000000;
  font-size: 16px; font-weight: 400;
  line-height: 22px;

  @include mobile {
    font-size: 13px;
  }
}

.content-img {
  width: 850px; height: 560px;
  margin-top: -110px;
  @include mobile {
    width: auto; height: auto;
    margin: 5px 0 16px;
  }
}

</style>
